import { Button, Modal } from "react-bootstrap";
import ThemedModal from "../../../@ui/Modal/ThemedModal";
import { BasketOverlapWarning } from "../../../types/Basket/BasketOverlapWarning";

export interface ConfirmOverlapCheckoutModalProps {
  show: boolean;
  warnings: BasketOverlapWarning[];
  onClose: () => void;
  onConfirmed: () => void;
  isProcessing: boolean;
}

export const ConfirmOverlapCheckoutModal = ({
  show,
  warnings,
  onClose,
  onConfirmed,
  isProcessing,
}: ConfirmOverlapCheckoutModalProps) => {
  return (
    <ThemedModal centered show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Overlapping Order Items</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          The following items in your basket overlap and may result in
          paying for duplicate data:
        </p>
        <ul style={{ overflowY: "auto", maxHeight: "200px" }}>
          {warnings.map((w, i) => (
            <li key={i}>
              {w.layerDisplayName} overlap by {w.overlapPercentage.toFixed(0)}%
            </li>
          ))}
        </ul>
        <p>Do you want to proceed with checkout anyway?</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onConfirmed} disabled={isProcessing}>
          Yes, proceed to checkout
        </Button>
      </Modal.Footer>
    </ThemedModal>
  );
};
